import { Title, TitleProps } from '@mantine/core';

function NliTitle({ children, ...props } : TitleProps) {
    return <Title
        {...props}
    >
        {typeof children === 'string' ? children.toUpperCase() : children}
    </Title>;
}

export { NliTitle };
